import { Component, inject, output, signal } from '@angular/core';
import { take } from 'rxjs/operators';
import { IceTextareaComponent } from '@app/shared/components/molecules/ice-textarea/ice-textarea.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatDialogClose, MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { VerificationService } from '@app/sales/services/verification.service';
import { UserSelectors } from '@app/core/states/user/user.selectors';
import { Store } from '@ngxs/store';
import { NotificationService } from '@app/core/services/notification.service';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { IceIconButtonComponent } from '@app/shared/components/atoms/ice-icon-button/ice-icon-button.component';

@Component({
  selector: 'app-bypass-order-modal',
  imports: [
    IceTextareaComponent,
    FormsModule,
    MatDialogClose,
    MatDialogTitle,
    ReactiveFormsModule,
    IceButtonComponent,
    IceAlertComponent,
    IceIconButtonComponent,
  ],
  templateUrl: './bypass-order-modal.component.html',
  styleUrls: ['./bypass-order-modal.component.scss'],
})
export class BypassOrderModal {
  verificationService = inject(VerificationService);
  private store = inject(Store);
  private data = inject(MAT_DIALOG_DATA) as { orderServiceId: number } | null;
  private dialogRef = inject(MatDialogRef<BypassOrderModal>);
  notificationService = inject(NotificationService);

  bypassSuccess = output<void>();

  isLoading = signal(false);

  userId = this.store.selectSnapshot(UserSelectors.userId);

  IconNames = IconNames;
  form = new FormGroup({
    bypassReason: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
  });

  submitBypass() {
    if (!this.data?.orderServiceId) return;
    const orderServiceId = this.data.orderServiceId;
    const notes = this.form.value.bypassReason || '';

    this.isLoading.set(true);
    this.verificationService
      .bypassBankIdVerification(orderServiceId.toString(), notes, this.userId)
      .pipe(take(1))
      .subscribe({
        next: _response => {
          this.isLoading.set(false);
          this.dialogRef.close(true);
          this.bypassSuccess.emit();
        },
        error: error => {
          this.isLoading.set(false);
          const errorMessage = error?.error || 'Noe gikk galt ved omgåelse av BankID-verifisering.';
          this.notificationService.error(errorMessage);
        },
      });
  }
}
